/** @jsxImportSource @emotion/react */
import { jsx, css } from "@emotion/react";
import BottomMenu from "./BottomMenu";
import {
  Grid,
  Box,
  TextField,
  IconButton,
  Dialog,
  DialogTitle,
  DialogActions,
  Button,
  Slide,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Rating,
  Divider,
  Chip,
  Paper,
} from "@mui/material";
import EventNoteIcon from "@mui/icons-material/EventNote";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import StaticDatePicker from "@mui/lab/StaticDatePicker";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import React, { useState, forwardRef, useEffect } from "react";
import { Badge } from "@mui/material";
import moment from "moment";
import PickersDay from "@mui/lab/PickersDay";
import DateFnsUtils from "@date-io/date-fns";
import { ko } from "date-fns/locale";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import styled from "styled-components";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import Swal from "sweetalert2";
import { useHistory } from "react-router-dom";
import ClearIcon from "@mui/icons-material/Clear";
import Login from "./Login";
import { useRecoilValue } from "recoil";
import { loginState, configState } from "../lib/State";
import pr from "../lib/pr";
import BottomButton from "./BottomButton";
import { buttonClasses } from "@mui/material";
import axios from "axios";
import "moment/locale/ko";
import get_token from "../lib/get_token";
import get_cid from "../lib/get_cid";
import get_center from "../lib/get_center";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const theme = createTheme({
  components: {
    MuiPickerStaticWrapper: {
      styleOverrides: {
        root: {
          maxHeight: "328px",
          height: "100%",
        },
      },
    },
    MuiCalendarPicker: {
      styleOverrides: {
        root: {
          zIndex: 2,
        },
      },
    },
  },
});

const inputTheme = createTheme({
  components: {
    MuiInputLabel: {
      styleOverrides: {
        root: {
          top: "-13.5px",
          fontSize: "14px",
        },
        shrink: {
          // top: '-6px'
          display: "none",
        },
        nativeInput: {
          fontSize: "14px",
        },
      },
    },
  },
});
function BookGroup() {
  const [classname, setClassname] = useState("");
  const [classmemo, setClassmemo] = useState("");
  const [tname, setTname] = useState("");
  const [openLecture, setOpenLecture] = useState(false);
  const [avg, setAvg] = useState(0);
  const [cnt, setCnt] = useState(0);
  const cid = get_cid();
  const center = get_center(cid);
  const [sdate, setSdate] = useState(moment().format("YYYY-MM-DD")); // 선택날짜
  const [tcid, setTcid] = useState("");
  const [teacher, setTeacher] = useState([]);
  const [teacher2, setTeacher2] = useState([]);
  const [ptmanagers, setPtmanagers] = useState([]);
  const [pttrainers, setPttrainers] = useState([]);
  const [ratings, setRatings] = useState([]);
  const [ratings2, setRatings2] = useState([]);
  //강좌리스트
  const [lectures, setLectures] = useState([]);

  //로그인 세션
  const [loaded, setLoaded] = useState(false);
  const [login, setLogin] = useState(loginState);
  const token = get_token();

  // 로그인
  // const login = useRecoilValue(loginState);
  // const config = useRecoilValue(configState);

  const [date, setDate] = useState(moment());
  const [highlightedDays, setHighlightedDays] = useState([1, 2, 15, 26]);

  const history = useHistory();

  const [openLogin, setOpenLogin] = useState(false);
  const clickOpenLogin = () => {
    setOpenLogin(true);
  };

  const clickCloseLogin = () => {
    setOpenLogin(false);
    setOpenAlert(false); // 알럿창 닫기
  };

  const [openAlert, setOpenAlert] = useState(false);

  const minDate = new Date(moment().add(-1, "years"));
  const maxDate = new Date(moment().add(+1, "years"));

  //오늘날짜와 같거나 이전인 날짜들을 선택 못하게
  // const disableDate = (date) => {
  //     return date <= (new Date())
  // }

  //로그인 세션
  const get_session = async () => {
    let result = await axios.post(configState.api + "/gympass/get_session", {
      token: token,
      cid: cid,
    });
    if (result.data.mcd !== "" && result.data.success === 1) {
      setLogin({ mcd: result.data.mcd, level: result.data.level });
    }
    setLoaded(true);
  };

  useEffect(() => {
    get_session();
  }, []);

  useEffect(() => {
    load_data();
  }, [tcid]);

  // 날짜 변경시 수업리스트 새로 가져옴
  const onChangeDate = (newDate) => {
    setSdate(moment(newDate).format("YYYY-MM-DD"));
  };

  // 예약 가져오기
  const load_data = async () => {
    let result = await axios.post(
      configState.api + "/gympass/reservation_class",
      {
        token: token,
        mcd: login.mcd,
        level: login.level,
        cid: cid,
        sdate: sdate,
        // tcid: cid
      }
    );

    if (result.data.success === 1) {
      setLectures(result.data.rows);
    } else {
      Swal.fire(result.data.msg);
    }
  };

  // PT 가져오기
  const load_data2 = async () => {
    let result = await axios.post(
      configState.api + "/gympass/reservation_class_pt",
      {
        token: token,
        mcd: login.mcd,
        level: login.level,
        cid: cid,
        sdate: sdate,
      }
    );

    if (result.data.success === 1) {
      setTeacher(result.data.teacher);
      setTeacher2(result.data.teacher2);
      setPtmanagers(result.data.ptmanagers);
      setPttrainers(result.data.pttrainers);
      setRatings2(result.data.ratings2);
    } else {
      Swal.fire(result.data.msg);
      // Swal.fire('error')
    }
  };

  useEffect(() => {
    if (loaded) {
      // pr('loaded:'+loaded);
      // pr('sdate:'+sdate);
      load_data();
      load_data2();
    }
  }, [loaded, sdate, login]);

  // 예약하기 클릭
  const onReservationClick = (params) => {
    const { tcd, hour, classname, tname, classmemo, pt_type } = params;
    Swal.fire({
      html: `<div>${moment(sdate).format("YYYY년 MM월 DD일")} ${hour.slice(
        0,
        2
      )}시 ${moment(sdate).format("dddd")}</div>
      <div>${classname} - ${tname}</div>
      <br />
      <div class="text-sm text-red-500">* 수업 시작 24시간 전까지만 취소가 가능합니다.</div>
      `,
      title: "예약하시겠습니까?",
      showConfirmButton: true,
      showCancelButton: true,
    })
      .then(async (result) => {
        if (result.isConfirmed) {
          let result = await axios.post(
            configState.api + "/gympass/reservation_add",
            {
              token: token,
              mcd: login.mcd,
              level: login.level,
              cid: cid,
              tcd: tcd,
              hour: hour,
              sdate: sdate,
              pt_type: pt_type,
            }
          );
          if (result.data.success === 1) {
            if (result.data.pid === "DOC00000004") {
              // 체험 쿠폰인 경우 welcome SMS 메시지 발송
              result = await axios.post(configState.api + "/push/sms_trial", {
                cid: cid,
                token: token,
                mcd: login.mcd,
                level: login.level,
              });

              // 체험쿠폰인 경우 별도 공지
              result = await axios.post(configState.api + "/push/to_mcd", {
                cid: cid,
                mcd: login.mcd,
                title: "공지",
                message: `안녕하세요 회원님, 저희 두써킷 센터를 예약해 주셔서 감사합니다. 
                
첫 방문시 준비물은 운동화(신고오셔도 됩니다), 운동복(입고오셔도 됩니다)만 준비하시면 됩니다. 물론 탈의실이 있어 수업 전 모두 갈아입으실 수도 있습니다. 

첫 수업전에 저희 센터의 시스템 이용에 관한 간단한 설명을 해드리고자 하오니, 예약 수업전 15분만 일찍 방문해 주시면 담당자가 안내해 드릴 것입니다.

회원님을 만날 생각에 벌써부터 설레입니다. 오셔서 함께 땀흘려보시죠^^ 두팔벌려 기다리고 있겠습니다. 감사합니다.`,
              });
              Swal.fire("예약 되었습니다.")
                .then(() => {
                  load_data();
                })
                .catch((e) => Swal.fire(e));
            } else {
              result = await axios.post(configState.api + "/push/to_mcd", {
                cid: cid,
                mcd: login.mcd,
                title: "예약",
                message: `${moment(sdate).format("M월 D일")} ${hour.slice(
                  0,
                  2
                )}시 ${classname} 수업 예약이 완료되었습니다.`,
              });
              Swal.fire("예약 되었습니다.")
                .then(() => {
                  load_data();
                })
                .catch((e) => Swal.fire(e));
            }
          } else {
            Swal.fire("ERROR", result.data.msg);
          }
        }
      })
      .catch((e) => Swal.fire(e));
  };

  const onLoginClick = () => {
    Swal.fire({
      title: "로그인 하시겠습니까?",
      showConfirmButton: true,
      showCancelButton: true,
    })
      .then(async (result) => {
        if (result.isConfirmed) {
          setOpenLogin(true);
        }
      })
      .catch((e) => Swal.fire(e));
  };

  const openLectureInfo = async (params) => {
    const { classname, classmemo, tname, tcd } = params;
    setClassname(classname);
    setTname(tname);
    setClassmemo(classmemo);

    let result = await axios.post(
      configState.api + "/gympass/rating_lectures",
      {
        token: token,
        cid: cid,
        mcd: login.mcd,
        level: login.level,
        tcd: tcd,
      }
    );

    if (result.data.success === 1) {
      setAvg(result.data.avg);
      setCnt(result.data.cnt);
      setOpenLecture(true);
      // Swal.fire({
      //   html: `
      //   <div
      //     style='text-align: left;'>
      //   <div
      //     style='display: flex;
      //     align-items: flex-end;
      //     font-weight: bold;
      //     margin-bottom: 10px;'>
      //     <div>${classname}</div>
      //     <div style='font-size: 14px; margin-left: 10px;'>${tname}</div>
      //     <Rating defaultValue=${average.avg} precision=${0.5} sx={{ fontSize: '14pt' }} readOnly />
      //   </div>
      //   <div>${classmemo === 'null' ? '수업 내용이 없습니다.' : classmemo}</div>
      //   </div>
      //   `
      // })
    }
  };

  const ptSubmit = (params) => {
    const { tcd, hour, tname, pt_type } = params;
    Swal.fire({
      html: `<div>${moment(sdate).format("YYYY년 MM월 DD일")} ${hour.slice(
        0,
        2
      )}시 ${moment(sdate).format("dddd")}</div>
      <div>${tname} 트레이너 PT 수업을 예약하시겠습니까?</div>
      `,
      showConfirmButton: true,
      showCancelButton: true,
    })
      .then(async (result) => {
        if (result.isConfirmed) {
          let result = await axios.post(
            configState.api + "/gympass/reservation_add",
            {
              token: token,
              mcd: login.mcd,
              level: login.level,
              cid: cid,
              tcd: tcd,
              hour: hour,
              sdate: sdate,
              pt_type: pt_type,
            }
          );
          if (result.data.success === 1) {
            result = await axios.post(configState.api + "/push/to_mcd", {
              cid: cid,
              mcd: login.mcd,
              title: "예약",
              message: `${moment(sdate).format(
                "YYYY년 MM월 DD일"
              )} ${hour.slice(
                0,
                2
              )}시 ${tname} 강사 PT 수업 예약이 완료되었습니다.`,
            });
            Swal.fire("예약 되었습니다.")
              .then(() => {
                load_data2();
              })
              .catch((e) => Swal.fire(e));
          } else {
            Swal.fire("ERROR", result.data.msg);
          }
        }
      })
      .catch((e) => Swal.fire(e));
  };

  const ptLogin = () => {
    Swal.fire({
      title: "로그인 하시겠습니까?",
      showConfirmButton: true,
      showCancelButton: true,
    })
      .then(async (result) => {
        if (result.isConfirmed) {
          setOpenLogin(true);
        }
      })
      .catch((e) => Swal.fire(e));
  };

  return (
    <Grid container direction="column">
      <div
        className="absolute z-30 bg-white rounded-full bg-opacity-50 top-3 left-3"
        onClick={() => history.goBack()}
      >
        <img src="/img/back_button_black.png" alt="" />
      </div>
      <Dialog
        open={openLecture}
        onClose={() => setOpenLecture(false)}
        fullWidth
      >
        <Box
          sx={{
            padding: "20px",
            wordBreak: "keep-all",
          }}
        >
          <Box
            sx={{
              display: "flex",
              marginBottom: "5px",
              alignItems: "center",
            }}
          >
            <Box
              sx={{
                fontWeight: "bold",
                fontSize: "15px",
              }}
            >
              {classname}
            </Box>
            <Box
              sx={{
                fontSize: "14px",
                marginLeft: "5px",
              }}
            >
              {tname}
            </Box>
            {cnt === 0 && (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Rating
                  defaultValue={parseFloat(avg)}
                  precision={0.5}
                  sx={{ fontSize: "16px" }}
                  readOnly
                />
                <Box
                  sx={{
                    fontWeight: "bold",
                    fontSize: "15px",
                  }}
                >
                  {avg}
                </Box>
              </Box>
            )}
            {cnt > 0 && (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Rating
                  defaultValue={parseFloat(avg)}
                  precision={0.5}
                  sx={{ fontSize: "16px" }}
                  readOnly
                />
                <Box
                  sx={{
                    fontWeight: "bold",
                    fontSize: "15px",
                  }}
                >
                  {avg}
                </Box>
                <Box
                  sx={{
                    fontSize: "13px",
                  }}
                >
                  ({cnt}회)
                </Box>
              </Box>
            )}
          </Box>
          <Box
            sx={{
              marginBottom: "10px",
              fontSize: "14px",
            }}
            dangerouslySetInnerHTML={{
              __html: classmemo.replaceAll("\n", "<br/>"),
            }}
          />
          <Box
            sx={{
              width: "100%",
              textAlign: "center",
            }}
          >
            <Button
              variant="contained"
              onClick={() => setOpenLecture(false)}
              sx={{
                background: "#0092a2",
              }}
            >
              확인
            </Button>
          </Box>
        </Box>
      </Dialog>
      <Dialog
        fullScreen
        open={openLogin}
        TransitionComponent={Transition}
        onClose={clickCloseLogin}
      >
        <Box
          sx={{
            width: "90%",
            textAlign: "left",
            padding: "30px 0 10px 10px",
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
          }}
        >
          <img src="/img/back_button_black.png" onClick={clickCloseLogin} />
          <Box
            sx={{
              margin: "16px 0 0 10px",
              fontSize: "25px",
              fontWeight: "bold",
            }}
          >
            로그인
          </Box>
        </Box>
        <Login onCloseLogin={clickCloseLogin}></Login>
      </Dialog>
      <Box
        sx={{
          width: "100%",
          height: "50px",
          background: "black",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <img src={center.logo} height="35px" />
      </Box>
      <Box
        style={{
          // position: "fixed",
          top: 0,
          width: "100%",
          height: "260px",
          overflow: "hidden",
          zIndex: 10,
          position: "relative",
        }}
      >
        <img src="/img/book_header_noword.png" style={{ width: "100%" }} />
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            // fontWeight: 'bold'
          }}
        >
          <Box
            sx={{
              fontSize: "46px",
              fontFamily: "BebasNeue",
              color: "white",
            }}
          >
            RESERVATION
          </Box>
          {/* <Box
            sx={{
              fontSize: "18px",
              color: "white",
              fontWeight: "bold",
              textAlign: "center",
              marginTop: "-6px",
            }}
          >
            수업예약
          </Box> */}
        </Box>
      </Box>
      <Grid
        container
        flex="1"
        justifyContent="center"
        alignItems="center"
        sx={{ width: "100%", height: "100%" }}
      >
        <>
          <Grid
            sx={{
              zIndex: 1,
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            {/* <Box sx={{ height: "50px" }}></Box> */}
            <Box
              sx={{
                display: "flex",
                width: "90%",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  fontSize: "14px",
                  // width: '90%',
                  fontWeight: "bold",
                  mt: 2,
                }}
              >
                예약 진행 순서
              </Box>
            </Box>

            <Box
              sx={{
                fontSize: "14px",
                width: "90%",
              }}
            >
              원하는 날짜를 선택하시면 수업 목록이 나옵니다.
              <br></br>
              로그인 후 클래스를 선택하시면 바로 예약 가능합니다.
            </Box>

            <ThemeProvider theme={theme}>
              {/* localiszationprovider에서 locale로 설정을 해주면 해당 국가에 맞게 날짜형식 변경 */}
              <LocalizationProvider dateAdapter={AdapterDateFns} locale={ko}>
                <StaticDatePicker
                  sx={{
                    "&.MuiPickerStaticWrapper": { width: "100%" },
                    ["&&.MuiTypography-caption"]: {
                      color: "black",
                    },
                  }}
                  autoOk
                  views={["year", "month", "day"]}
                  displayStaticWrapperAs="desktop"
                  // shouldDisableDate={disableDate}
                  value={date}
                  minDate={minDate}
                  maxDate={maxDate}
                  onChange={onChangeDate}
                  renderInput={(params) => <TextField {...params} />}
                  //날짜에 badge로 표시하기
                  renderDay={(day, value, DayComponentProps) => {
                    var d = moment(day).format("DD");
                    const isSelected =
                      !DayComponentProps.outsideCurrentMonth &&
                      highlightedDays.indexOf(day.getDate()) > 0;
                    return (
                      <Grid key={d}>
                        <PickersDay
                          {...DayComponentProps}
                          // 선택된 날짜 #0092a2 색으로 출력
                          sx={{
                            // fontWeight: "bold",
                            fontSize: "15px",
                            ["&&.Mui-selected"]: {
                              background: "#0092a2",
                              color: "white",
                            },
                            borderRadius: "100%",
                            padding: "0 2px",
                            // border: "1px solid gray",
                            "&.MuiPickersDay-today": {
                              border: "1px solid #0092a2",
                              color: "#0092a2",
                            },
                            width: "36px",
                            height: "36px",
                            isSelected: { background: "black", color: "white" },
                          }}
                        />
                      </Grid>
                    );
                  }}
                />
              </LocalizationProvider>
            </ThemeProvider>
          </Grid>
          {/* 일정 */}

          <Grid
            className="table"
            style={{ width: "100%", marginBottom: "5px" }}
          >
            <Box
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Box
                sx={{
                  fontSize: "16px",
                  width: "90%",
                  fontWeight: "bold",
                  mb: 2,
                }}
              >
                그룹수업
              </Box>
            </Box>
            <Box
              className="tabletitle"
              style={{
                background: "#c7c7c7",
                textAlign: "center",
                color: "#414042",
                padding: "5px",
              }}
            >
              {moment(sdate).format("YYYY년 MM월 DD일")}
            </Box>
            {/* {lectures.filter(lecture => lecture.day === moment(date).format('YYYY-MM-DD'))} */}

            {login.mcd === undefined ||
            (login.mcd === "" && lectures.length > 0) ? (
              <>
                {lectures.map((item, index) => {
                  let is_applicate = false; // 예약가능
                  if (item.count < item.max_count) {
                    if (
                      moment(sdate + " " + item.shour).format("YYYY-MM-DD HH") >
                      moment().format("YYYY-MM-DD HH")
                    )
                      is_applicate = true;
                  }
                  let state = "";
                  if (is_applicate && item.max_count != 0) {
                    if (item.max_count - item.count <= 3) state = "마감임박";
                  }
                  if (item.max_count != 0 && item.max_count - item.count === 0)
                    state = "마감";
                  
                  return (
                    <Grid
                      key={index}
                      container
                      direction="row"
                      style={{
                        borderBottom: "solid 0.5px #c7c7c7",
                        padding: "5px 0",
                      }}
                      className={`${state === "마감임박" ? "bg-red-200" : ""} ${
                        state === "마감" ? "bg-zinc-300" : ""
                      }`}
                    >
                      <Grid
                        className="time"
                        container
                        alignItems="center"
                        justifyContent="center"
                        flexDirection="column"
                        item
                        xs={3}
                        style={{
                          borderRight: "dotted 0.5px gray",
                          fontSize: "13px",
                        }}
                      >
                        {item.shour}
                        <Box
                          sx={{
                            fontSize: "13px",
                            background: "#0092a2",
                            color: "white",
                            borderRadius: "5px",
                            padding: "2px 5px",
                          }}
                          onClick={() =>
                            openLectureInfo({
                              classname: item.class_name,
                              classmemo: item.class_memo,
                              tname: item.tname,
                              tcd: item.tcd,
                            })
                          }
                        >
                          수업안내
                        </Box>
                      </Grid>
                      <Grid
                        className="discription"
                        container
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                        style={{
                          padding: "5px",
                        }}
                        item
                        xs
                        onClick={() => onLoginClick()}
                      >
                        <Grid justifyContent="center">
                          <Box
                            sx={{
                              fontWeight: "bold",
                            }}
                          >
                            {item.class_name}
                            {state !== "" && (
                              <span
                                className={`text-xs text-white px-1 py-[0.1rem] ${
                                  state === "마감임박" ? "bg-red-500" : ""
                                } ${
                                  state === "마감" ? "bg-zinc-500" : ""
                                } rounded mx-1`}
                              >
                                {state}
                              </span>
                            )}
                          </Box>
                          <Box
                            sx={{
                              fontSize: "13px",
                            }}
                          >
                            {item.tname}
                            <br />
                          </Box>
                        </Grid>
                        {is_applicate ? (
                          <Grid
                            className="btnres"
                            sx={{
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <Box
                              sx={{
                                fontSize: "14px",
                              }}
                            ></Box>
                            <img
                              src="/img/back_button_black.png"
                              style={{ transform: "scaleX(-1)" }}
                            />
                            {/* <Button hour="09:00" tcd="5555" variant='contained' onClick={() => onReservationClick({ tcd: item.tcd, hour: item.shour })}>
                          예약하기
                        </Button> */}
                          </Grid>
                        ) : (
                          <></>
                        )}
                      </Grid>
                    </Grid>
                  );
                })}
              </>
            ) : (
              // 로그인
              lectures.map((item, index) => {
                let is_applicate = false; // 예약가능 (당일가능)
                if (item.count < item.max_count) {
                  if (
                    moment(sdate + " " + item.shour).format("YYYY-MM-DD HH") >
                    moment().format("YYYY-MM-DD HH")
                  )
                    is_applicate = true;
                }
                let state = "";
                if (is_applicate && item.max_count != 0) {
                  if (item.max_count - item.count <= 3) state = "마감임박";
                }
                if (item.max_count != 0 && item.max_count - item.count === 0)
                  state = "마감";

                return (
                  <Grid
                    key={index}
                    container
                    direction="row"
                    style={{
                      borderBottom: "solid 0.5px #c7c7c7",
                      padding: "5px 0",
                      // borderTop: "none",
                    }}
                    // onClick={() => {
                    //   if (is_applicate) {
                    //     onReservationClick({ tcd: item.tcd, hour: item.shour, classname: item.class_name, tname: item.tname, classmemo: item.class_memo });
                    //   }
                    // }}
                    className={`${state === "마감임박" ? "bg-red-200" : ""} ${
                      state === "마감" ? "bg-zinc-300" : ""
                    }`}
                  >
                    <Grid
                      className="time"
                      container
                      alignItems="center"
                      justifyContent="center"
                      flexDirection="column"
                      item
                      xs={3}
                      style={{
                        borderRight: "dotted 0.5px gray",
                        fontSize: "13px",
                      }}
                    >
                      {item.shour}
                      <Box
                        sx={{
                          fontSize: "13px",
                          background: "#0092a2",
                          color: "white",
                          borderRadius: "5px",
                          padding: "2px 5px",
                        }}
                        onClick={() =>
                          openLectureInfo({
                            classname: item.class_name,
                            classmemo: item.class_memo,
                            tname: item.tname,
                            tcd: item.tcd,
                          })
                        }
                      >
                        수업안내
                      </Box>
                    </Grid>
                    <Grid
                      className="discription"
                      container
                      direction="row"
                      justifyContent="space-between"
                      alignItems="center"
                      style={{
                        padding: "5px",
                      }}
                      item
                      xs
                      onClick={() => {
                        if (is_applicate) {
                          onReservationClick({
                            tcd: item.tcd,
                            hour: item.shour,
                            classname: item.class_name,
                            tname: item.tname,
                            classmemo: item.class_memo,
                            pt_type: item.pt_type,
                          });
                        }
                      }}
                    >
                      <Grid justifyContent="center">
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "flex-start",
                          }}
                        >
                          <Box
                            sx={{
                              fontWeight: "bold",
                            }}
                          >
                            {item.class_name}
                            {state !== "" && (
                              <span
                                className={`text-xs text-white px-1 py-[0.1rem] ${
                                  state === "마감임박" ? "bg-red-500" : ""
                                } ${
                                  state === "마감" ? "bg-zinc-500" : ""
                                } rounded mx-1`}
                              >
                                {state}
                              </span>
                            )}
                          </Box>
                        </Box>

                        <Box
                          sx={{
                            fontSize: "13px",
                          }}
                        >
                          {item.tname}
                        </Box>
                      </Grid>
                      {is_applicate ? (
                        <Grid
                          className="btnres"
                          sx={{
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <Box
                            sx={{
                              fontSize: "14px",
                            }}
                          >
                            {login.level === "teacher"
                              ? item.count + "/" + item.max_count
                              : "예약가능"}
                          </Box>
                          <img
                            src="/img/back_button_black.png"
                            style={{ transform: "scaleX(-1)" }}
                          />
                          {/* <Button hour="09:00" tcd="5555" variant='contained' onClick={() => onReservationClick({ tcd: item.tcd, hour: item.shour })}>
                          예약하기
                        </Button> */}
                        </Grid>
                      ) : (
                        <>
                          {/* <Button variant='contained' disabled>마감</Button> */}
                        </>
                      )}
                    </Grid>
                  </Grid>
                );
              })
            )}

            {/* 데이타 없음 */}
            {lectures.length === 0 && (
              <>
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  sx={{ minHeight: 150 }}
                >
                  수업이 없습니다
                </Box>
                <Divider flexItem />
              </>
            )}

            {center.pt_coupon_sale === true && (
              <>
                <Box
                  sx={{
                    mt: 4,
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  {(teacher.length === 0 && teacher2.length === 0) ||
                  (pttrainers.length === 0 &&
                    ptmanagers.length === 0) ? null : (
                    <Box
                      sx={{
                        fontSize: "16px",
                        width: "90%",
                        fontWeight: "bold",
                      }}
                    >
                      PT수업
                    </Box>
                  )}
                  {teacher.length > 0 &&
                    (login.mcd === undefined || login.mcd === "" ? (
                      <>
                        <Box
                          sx={{
                            width: "100%",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                          }}
                        >
                          {teacher.length > 0 && ptmanagers.length > 0 && (
                            <Box
                              sx={{
                                fontSize: "16px",
                                width: "100%",
                                fontWeight: "bold",
                                // mb: 1,
                                marginTop: "12px",
                              }}
                            >
                              <Box
                                sx={{
                                  fontWeight: 400,
                                  margin: "5px 0",
                                  background: "rgb(199, 199, 199)",
                                  textAlign: "center",
                                  padding: "5px",
                                  color: "rgb(65, 64, 66)",
                                }}
                              >
                                점장 PT
                              </Box>
                            </Box>
                          )}
                          <Box
                            sx={{
                              width: "100%",
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                            }}
                          >
                            {teacher.length > 0 &&
                              ptmanagers.length > 0 &&
                              teacher.map((item, index) => {
                                let temp = ptmanagers;
                                temp = temp.filter(
                                  (el) => el.tcd === item.tcd && el.count === 0
                                );
                                let tmp = -1;
                                let avg = 0;
                                let cnt = 0;
                                tmp = ratings.findIndex(
                                  (el) => el.tcd === item.tcd
                                );
                                if (tmp > -1) {
                                  avg = ratings[tmp].avg;
                                  cnt = ratings[tmp].cnt;
                                }
                                return (
                                  <React.Fragment key={index}>
                                    {temp.length > 0 && (
                                      <Paper
                                        elevation={3}
                                        key={index}
                                        sx={{
                                          marginBottom: "5px",
                                          marginTop: "10px",
                                          width: "95%",
                                          padding: "15px 0",
                                        }}
                                      >
                                        <>
                                          <Box
                                            sx={{
                                              display: "flex",
                                              justifyContent: "center",
                                              width: "100%",
                                            }}
                                          >
                                            <Box
                                              sx={{
                                                fontSize: 14,
                                                width: "90%",
                                                display: "flex",
                                                alignItems: "center",
                                              }}
                                            >
                                              <Box>{item.tname}</Box>
                                              <Rating
                                                value={parseFloat(avg)}
                                                precision={0.5}
                                                sx={{ fontSize: "16px" }}
                                                readOnly
                                              />
                                              <Box
                                                sx={{
                                                  fontWeight: "bold",
                                                }}
                                              >
                                                {avg}
                                              </Box>
                                            </Box>
                                          </Box>
                                          <Box
                                            sx={{
                                              display: "flex",
                                              width: "100%",
                                              justifyContent: "center",
                                            }}
                                          >
                                            <Box
                                              sx={{
                                                width: "90%",
                                                display: "flex",
                                                flexWrap: "wrap",
                                                justifyContent: "flex-start",
                                                gap: "0 3px",
                                              }}
                                            >
                                              {temp.map((item2, index2) => {
                                                return (
                                                  <Box
                                                    key={index2}
                                                    sx={{
                                                      // width: '20%',
                                                      display: "flex",
                                                      justifyContent: "center",
                                                    }}
                                                  >
                                                    <Chip
                                                      variant="outlined"
                                                      label={item2.shour}
                                                      onClick={ptLogin}
                                                      sx={{
                                                        margin:
                                                          "5px 2px 5px 0px",
                                                      }}
                                                    />
                                                  </Box>
                                                );
                                              })}
                                            </Box>
                                          </Box>
                                        </>
                                      </Paper>
                                    )}
                                  </React.Fragment>
                                );
                              })}
                          </Box>
                        </Box>
                      </>
                    ) : (
                      <>
                        <Box
                          sx={{
                            width: "100%",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                          }}
                        >
                          {teacher.length > 0 && ptmanagers.length > 0 && (
                            <Box
                              sx={{
                                fontSize: "16px",
                                width: "100%",
                                fontWeight: "bold",
                                // mb: 1,
                                marginTop: "12px",
                              }}
                            >
                              <Box
                                sx={{
                                  fontWeight: 400,
                                  margin: "5px 0",
                                  background: "rgb(199, 199, 199)",
                                  textAlign: "center",
                                  padding: "5px",
                                  color: "rgb(65, 64, 66)",
                                }}
                              >
                                점장 PT
                              </Box>
                            </Box>
                          )}
                          <Box
                            sx={{
                              width: "100%",
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                            }}
                          >
                            {teacher.length > 0 &&
                              ptmanagers.length > 0 &&
                              teacher.map((item, index) => {
                                let temp = ptmanagers;
                                temp = temp.filter(
                                  (el) => el.tcd === item.tcd && el.count === 0
                                );
                                let tmp = -1;
                                let avg = 0;
                                let cnt = 0;
                                tmp = ratings.findIndex(
                                  (el) => el.tcd === item.tcd
                                );
                                if (tmp > -1) {
                                  avg = ratings[tmp].avg;
                                  cnt = ratings[tmp].cnt;
                                }
                                return (
                                  <React.Fragment key={index}>
                                    {temp.length > 0 && (
                                      <Paper
                                        elevation={3}
                                        sx={{
                                          marginBottom: "5px",
                                          marginTop: "10px",
                                          width: "95%",
                                          padding: "15px 0",
                                        }}
                                      >
                                        <>
                                          <Box
                                            sx={{
                                              display: "flex",
                                              justifyContent: "center",
                                              width: "100%",
                                            }}
                                          >
                                            <Box
                                              sx={{
                                                fontSize: 14,
                                                width: "90%",
                                                display: "flex",
                                                alignItems: "center",
                                              }}
                                            >
                                              <Box>{item.tname}</Box>
                                              <Rating
                                                value={parseFloat(avg)}
                                                precision={0.5}
                                                sx={{ fontSize: "16px" }}
                                                readOnly
                                              />
                                              <Box
                                                sx={{
                                                  fontWeight: "bold",
                                                }}
                                              >
                                                {avg}
                                              </Box>
                                            </Box>
                                          </Box>
                                          {/* <Divider flexItem={true} /> */}
                                          <Box
                                            sx={{
                                              display: "flex",
                                              width: "100%",
                                              justifyContent: "center",
                                            }}
                                          >
                                            <Box
                                              sx={{
                                                width: "90%",
                                                display: "flex",
                                                flexWrap: "wrap",
                                                justifyContent: "flex-start",
                                                gap: "0 3px",
                                              }}
                                            >
                                              {temp.map((item2, index2) => {
                                                return (
                                                  <Box
                                                    key={index2}
                                                    sx={{
                                                      display: "flex",
                                                      justifyContent: "center",
                                                    }}
                                                  >
                                                    <Chip
                                                      variant="outlined"
                                                      label={item2.shour}
                                                      onClick={() =>
                                                        ptSubmit({
                                                          tcd: item2.tcd,
                                                          hour: item2.shour,
                                                          tname: item.tname,
                                                          pt_type:
                                                            item2.pt_type,
                                                        })
                                                      }
                                                      sx={{
                                                        margin:
                                                          "5px 2px 5px 0px",
                                                      }}
                                                    />
                                                  </Box>
                                                );
                                              })}
                                            </Box>
                                          </Box>
                                          {/* <Divider flexItem={true} /> */}
                                        </>
                                      </Paper>
                                    )}
                                  </React.Fragment>
                                );
                              })}
                          </Box>
                        </Box>
                      </>
                    ))}

                  {teacher.length === 0 && <></>}

                  {teacher2.length > 0 &&
                    (login.mcd === undefined || login.mcd === "" ? (
                      <>
                        <Box
                          sx={{
                            width: "100%",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                          }}
                        >
                          {teacher2.length > 0 && pttrainers.length > 0 && (
                            <Box
                              sx={{
                                fontSize: "16px",
                                width: "100%",
                                fontWeight: "bold",
                                // mb: 1,
                                marginTop: "12px",
                              }}
                            >
                              <Box
                                sx={{
                                  fontWeight: 400,
                                  margin: "5px 0",
                                  background: "rgb(199, 199, 199)",
                                  textAlign: "center",
                                  padding: "5px",
                                  color: "rgb(65, 64, 66)",
                                }}
                              >
                                트레이너 PT
                              </Box>
                            </Box>
                          )}
                          <Box
                            sx={{
                              width: "100%",
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                            }}
                          >
                            {teacher2.length > 0 &&
                              pttrainers.length > 0 &&
                              teacher2.map((item, index) => {
                                let temp = pttrainers;
                                temp = temp.filter(
                                  (el) => el.tcd === item.tcd && el.count === 0
                                );
                                let tmp = -1;
                                let avg = 0;
                                let cnt = 0;
                                tmp = ratings2.findIndex(
                                  (el) => el.tcd === item.tcd
                                );
                                if (tmp > -1) {
                                  avg = ratings2[tmp].avg;
                                  cnt = ratings2[tmp].cnt;
                                }
                                return (
                                  <React.Fragment key={index}>
                                    {temp.length > 0 && (
                                      <Paper
                                        elevation={3}
                                        key={index}
                                        sx={{
                                          marginBottom: "5px",
                                          marginTop: "10px",
                                          width: "95%",
                                          padding: "15px 0",
                                        }}
                                      >
                                        <>
                                          <Box
                                            sx={{
                                              display: "flex",
                                              justifyContent: "center",
                                              width: "100%",
                                            }}
                                          >
                                            <Box
                                              sx={{
                                                fontSize: 14,
                                                width: "90%",
                                                display: "flex",
                                                alignItems: "center",
                                              }}
                                            >
                                              <Box>{item.tname}</Box>
                                              <Rating
                                                value={parseFloat(avg)}
                                                precision={0.5}
                                                sx={{ fontSize: "16px" }}
                                                readOnly
                                              />
                                              <Box
                                                sx={{
                                                  fontWeight: "bold",
                                                }}
                                              >
                                                {avg}
                                              </Box>
                                            </Box>
                                          </Box>
                                          <Box
                                            sx={{
                                              display: "flex",
                                              width: "100%",
                                              justifyContent: "center",
                                            }}
                                          >
                                            <Box
                                              sx={{
                                                width: "90%",
                                                display: "flex",
                                                flexWrap: "wrap",
                                                justifyContent: "flex-start",
                                                gap: "0 3px",
                                              }}
                                            >
                                              {temp.map((item2, index2) => {
                                                return (
                                                  <Box
                                                    sx={{
                                                      display: "flex",
                                                      justifyContent: "center",
                                                    }}
                                                    key={index2}
                                                  >
                                                    <Chip
                                                      variant="outlined"
                                                      label={item2.shour}
                                                      onClick={ptLogin}
                                                      sx={{
                                                        margin:
                                                          "5px 2px 5px 0px",
                                                      }}
                                                    />
                                                  </Box>
                                                );
                                              })}
                                            </Box>
                                          </Box>
                                        </>
                                      </Paper>
                                    )}
                                  </React.Fragment>
                                );
                              })}
                          </Box>
                        </Box>
                      </>
                    ) : (
                      <>
                        <Box
                          sx={{
                            width: "100%",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                          }}
                        >
                          {teacher2.length > 0 && pttrainers.length > 0 && (
                            <Box
                              sx={{
                                fontSize: "16px",
                                width: "100%",
                                fontWeight: "bold",
                                // mb: 1,
                                marginTop: "12px",
                              }}
                            >
                              <Box
                                sx={{
                                  fontWeight: 400,
                                  marginTop: "5px",
                                  background: "rgb(199, 199, 199)",
                                  textAlign: "center",
                                  padding: "5px",
                                  color: "rgb(65, 64, 66)",
                                }}
                              >
                                트레이너 PT
                              </Box>
                            </Box>
                          )}
                          <Box
                            sx={{
                              width: "100%",
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                            }}
                          >
                            {teacher2.length > 0 &&
                              pttrainers.length > 0 &&
                              teacher2.map((item, index) => {
                                let temp = pttrainers;
                                temp = temp.filter(
                                  (el) =>
                                    el.tcd === item.tcd &&
                                    el.count === 0 &&
                                    moment(sdate + " " + el.shour).format(
                                      "YYYY-MM-DD HH:mm"
                                    ) > moment().format("YYYY-MM-DD HH:mm")
                                );
                                let tmp = -1;
                                let avg = 0;
                                let cnt = 0;
                                tmp = ratings2.findIndex(
                                  (el) => el.tcd === item.tcd
                                );
                                if (tmp > -1) {
                                  avg = ratings2[tmp].avg;
                                  cnt = ratings2[tmp].cnt;
                                }
                                return (
                                  <React.Fragment key={index}>
                                    {temp.length > 0 && (
                                      <Paper
                                        elevation={3}
                                        key={index}
                                        sx={{
                                          marginBottom: "5px",
                                          marginTop: "10px",
                                          width: "95%",
                                          padding: "15px 0",
                                        }}
                                      >
                                        <>
                                          <Box
                                            sx={{
                                              display: "flex",
                                              justifyContent: "center",
                                              width: "100%",
                                            }}
                                          >
                                            <Box
                                              sx={{
                                                fontSize: 14,
                                                width: "90%",
                                                display: "flex",
                                                alignItems: "center",
                                              }}
                                            >
                                              <Box>{item.tname}</Box>
                                              <Rating
                                                value={parseFloat(avg)}
                                                precision={0.5}
                                                sx={{ fontSize: "16px" }}
                                                readOnly
                                              />
                                              <Box
                                                sx={{
                                                  fontWeight: "bold",
                                                }}
                                              >
                                                {avg}
                                              </Box>
                                            </Box>
                                          </Box>
                                          <Box
                                            sx={{
                                              display: "flex",
                                              width: "100%",
                                              justifyContent: "center",
                                            }}
                                          >
                                            <Box
                                              sx={{
                                                width: "90%",
                                                display: "flex",
                                                flexWrap: "wrap",
                                                justifyContent: "flex-start",
                                                gap: "0 3px",
                                              }}
                                            >
                                              {temp.map((item2, index2) => {
                                                return (
                                                  <Box
                                                    sx={{
                                                      display: "flex",
                                                      justifyContent: "center",
                                                    }}
                                                    key={index2}
                                                  >
                                                    <Chip
                                                      variant="outlined"
                                                      label={item2.shour}
                                                      onClick={() =>
                                                        ptSubmit({
                                                          tcd: item2.tcd,
                                                          hour: item2.shour,
                                                          tname: item.tname,
                                                          pt_type:
                                                            item2.pt_type,
                                                        })
                                                      }
                                                      sx={{
                                                        margin:
                                                          "5px 2px 5px 0px",
                                                      }}
                                                    />
                                                  </Box>
                                                );
                                              })}
                                            </Box>
                                          </Box>
                                        </>
                                      </Paper>
                                    )}
                                  </React.Fragment>
                                );
                              })}
                          </Box>
                        </Box>
                      </>
                    ))}
                  {teacher2.length > 0 && pttrainers.length === 0 && (
                    <>
                      {/* <Box sx={{ mb: 2 }}></Box>
                <Divider flexItem />
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  sx={{ minHeight: 150 }}
                >
                  수업이 없습니다
                </Box>
                <Divider flexItem /> */}
                    </>
                  )}

                  {teacher2.length === 0 && <></>}
                  {((teacher.length === 0 && teacher2.length === 0) ||
                    (pttrainers.length === 0 && ptmanagers.length === 0)) && (
                    <>
                      {/* <Box sx={{ mb: 2 }}></Box>
                      <Divider flexItem />
                      <Box
                        sx={{
                          minHeight: "150px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        수업이 없습니다
                      </Box>
                      <Divider flexItem /> */}
                    </>
                  )}
                </Box>
              </>
            )}
            {login.mcd === undefined ||
              (login.mcd === "" && <Box sx={{ height: "50px" }}></Box>)}

            <Box sx={{ height: "100px" }}></Box>
          </Grid>
        </>
        {/* )} */}
      </Grid>
      {/* <div css={ css `border:1px solid #cccccc;`}>xxxxxx</div> */}
      <BottomButton login={login} loaded={loaded} />
      <BottomMenu active="book" sx={{ zIndex: 10 }}></BottomMenu>
    </Grid>
  );
}

export default BookGroup;
